import certificateDetailsLocale from './en.json'

const en = {
  certificateDetails: certificateDetailsLocale,
}

export default en
